export function isChunkParsed(chunk) {
  return (typeof chunk.parsedSize === 'number');
}



// WEBPACK FOOTER //
// ./client/utils.js